import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M11.647.29A3.173 3.173 0 0 0 9 1.71 3.173 3.173 0 0 0 6.353.29H0v16h6.353c1.105 0 2.078.565 2.647 1.421a3.174 3.174 0 0 1 2.647-1.421H18v-16h-6.353zM1.2 15.09V1.49h5.153c.663 0 1.279.331 1.648.885l.399.6v12.622a4.367 4.367 0 0 0-2.047-.508H1.2zm15.6 0h-5.153c-.726 0-1.426.179-2.047.508V2.975l.399-.601a1.975 1.975 0 0 1 1.648-.885H16.8V15.09z" />
  </svg>
);

export default SvgComponent;
